import React, {useEffect, useState} from 'react';
import {useMainScreenStyles} from '../mainScreenStyles';
import Grid from '@mui/material/Grid';
import {getPatientMainScreenButtons} from './buttons/buttonsCollections';
import {useEventListener} from '../../../../hooks/useEventListener';
import {useSelector} from 'react-redux';
import {ctxPatientType, ctxSplitScreen} from '../../../../store/reducers/patientContext';
import {PATIENT_CONTEXT_TYPE} from '../../../../util/patientContextUtil';
import PatientContextActivitySelector from '../../../patient/patientContext/components/patientContextActivitySelector';
import clsx from 'clsx';
import {isArray} from 'lodash';

const MainScreenGeneralInfo = ({patient, disableSave, container}) => {
    const classes = useMainScreenStyles();

    const patientType = useSelector(ctxPatientType);
    const splitScreen = useSelector(ctxSplitScreen);
    const isReview = patientType === PATIENT_CONTEXT_TYPE.REVIEW;

    const [columnCount, setColumnCount] = useState(isReview ? '1fr' : '1fr 1fr 1fr');
    const [columnsRenders, setColumnsRenders] = useState({
        firstCol: [],
        secondCol: [],
        thirdCol: [],
    });

    // Load button layout
    useEffect(() => {
        if (patientType) setColumnsRenders(getPatientMainScreenButtons(patient, patientType, disableSave));
    }, [patient, patientType, disableSave]);

    useEventListener('resize', getColumnCount);

    useEffect(() => {
        getColumnCount();
    }, [splitScreen?.enabled, patientType]);

    function getColumnCount() {
        if (isReview) return;
        const width = container?.offsetWidth ?? window.innerWidth;
        let columns = '1fr 1fr 1fr';
        if (width < 768) {
            columns = '1fr';
        } else if (width < 1118) {
            columns = '1fr 1fr';
        }
        setColumnCount(columns);
    }

    const renderColumn = (col) => {
        return (
            <div className={classes.topColumn}>
                {col.map((element, index) => (
                        <Grid item xs={12} key={index} style={{maxHeight: 'min-content', height: 'min-content'}}>
                            {element}
                        </Grid>
                    ),
                )}
            </div>
        );
    };

    const renderUpperColumns = () => {
        if (isReview) {
            return <PatientContextActivitySelector/>;
        } else {
            return (
                <>
                    {isArray(columnsRenders?.firstCol) && renderColumn(columnsRenders?.firstCol)}
                    {isArray(columnsRenders?.secondCol) && renderColumn(columnsRenders?.secondCol)}
                    {isArray(columnsRenders?.thirdCol) && renderColumn(columnsRenders?.thirdCol)}
                </>
            );
        }
    };

    return (
        <div
            className={clsx(isReview ? classes.reviewMainScreen : classes.gridMainScreen)}
            style={{gridTemplateColumns: columnCount}}
        >
            {renderUpperColumns()}
        </div>
    );
};

export default MainScreenGeneralInfo;